import { formatDayLabel } from '@/shared/lib';

import type { TimelineSection } from './TimelineViewer';

export type DaySectionItem = {
  __timestampMs: number | null;
  __dayKey: string | null;
};

export function buildDaySections<TItem extends DaySectionItem>(
  items: readonly TItem[]
): readonly TimelineSection<TItem>[] {
  const next = [...items];
  next.sort((a, b) => {
    const aMs = a.__timestampMs ?? -Infinity;
    const bMs = b.__timestampMs ?? -Infinity;
    return bMs - aMs;
  });

  const byDay = new Map<string | null, TItem[]>();
  for (const item of next) {
    const bucket = byDay.get(item.__dayKey);
    if (bucket) {
      bucket.push(item);
    } else {
      byDay.set(item.__dayKey, [item]);
    }
  }

  const dayKeys = Array.from(byDay.keys()).sort((a, b) => {
    if (a === null) {
      return 1;
    }
    if (b === null) {
      return -1;
    }
    return b.localeCompare(a);
  });

  return dayKeys.map((dayKey) => ({
    dayKey,
    dayLabel: formatDayLabel(dayKey),
    items: byDay.get(dayKey) ?? [],
  }));
}
